/* @flow */
import gql from 'graphql-tag';

export const flexibleDatesFragments = {
    SearchResult: gql`
        fragment FlexibleDatesSearchResult on SearchResult {
            percentBooked {
                currentPercentBooked
            }
        }
    `
};
